import React from 'react';
import { Redirect } from 'react-router-dom';
import { trackingOnboardingComplete } from 'services/analytics';

export const FinishOnboarding = () => {
  trackingOnboardingComplete();
  return <Redirect to="/?onboarding-complete=true" />;
};

export default FinishOnboarding;
